import React, { useEffect } from "react";
import styled from "styled-components";
import OtherTabs from "../../../components/AdminCentral/Other/OtherTabs";
import OtherAnnouncementsContent from "../../../components/AdminCentral/Other/OtherAnnouncementsContent";
import EmailLogContentComponent from "../../../components/AdminCentral/Other/EmailLogContentComponent";
import SalesPersonContent from "../../../components/AdminCentral/Other/SalesPersonContent";
import SalesRegionsContent from "../../../components/AdminCentral/Other/SalesRegionContent";
import ProductCodesContent from "../../../components/AdminCentral/Other/ProductCodesContent";
import OrganizationTypesContent from "../../../components/AdminCentral/Other/OrganizationTypesContent";
import WebinarContent from "../../../components/AdminCentral/Other/WebinarContent";
import MergeAccountsContent from "../../../components/AdminCentral/Other/MergeAccountContent";
import ResourcesContent from "../../../components/AdminCentral/Other/ResourcesContent";
import QuotesContent from "../../../components/AdminCentral/Admins/QuotesContent";
import RenewalContent from "../../../components/AdminCentral/Other/RenewalContent";
import usePersistentTabState from "../../../hooks/usePersistentTabState";

const breakpoints = {
  tablet: 768,
  phone:  480,
};


const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  min-height: 100vh;
  background-color: transparent;
   @media (max-width: ${breakpoints.phone}px) {
    padding: 12px;
    width: 400px;
    overflow: auto;

  }
`;

const Container = styled.div`
  width: 1100px;
  align-items: center;
  padding: 20px;
  // margin: 20px;
  font-family: Arial, sans-serif;
  border-radius: 5px;
  background-color: ${(props) => props.colors.cardBackground};
   @media (max-width: ${breakpoints.tablet}px) {
    width: 100%;
    padding: 16px;
  }
  @media (max-width: ${breakpoints.phone}px) {
    width: 100%;
    overflow: auto;
    padding: 12px;
  }
`;

const Title = styled.text`
  font-size: 36px;
  color: ${({ colors }) => colors.titleText};
  font-weight: 600;
  margin-bottom: 20px;
  #span {
    display: block;
    color: black;
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
`;

const TABS = [
  "Announcements",
  "Resources",
  "Salespersons",
  "Sales Regions",
  "Product Codes",
  "Organization Types",
  "Merge Accounts",
  "Renewals",
  "Email Log",
  "Quotes",
  "Webinar",
];

const OtherPage = ({ colors }) => {
  const [selectedTab, setSelectedTab] = usePersistentTabState(
    "admincentral.other.selectedTab",
    "Announcements"
  );

  useEffect(() => {
    if (!TABS.includes(selectedTab)) {
      setSelectedTab("Announcements");
    }
  }, [selectedTab, setSelectedTab]);

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <DashboardContainer>
      <Title colors={colors}> Other </Title>
      <Container colors={colors}>
        <OtherTabs
          colors={colors}
          selectedTab={selectedTab}
          handleTabClick={handleTabClick}
        />
        {selectedTab === "Announcements" && (
          <OtherAnnouncementsContent colors={colors} />
        )}
        {selectedTab === "Email Log" && (
          <EmailLogContentComponent colors={colors} />
        )}
        {selectedTab === "Salespersons" && (
          <SalesPersonContent colors={colors} onTabChange={handleTabClick} />
        )}
        {selectedTab === "Sales Regions" && (
          <SalesRegionsContent colors={colors} onTabChange={handleTabClick} />
        )}
        {selectedTab === "Product Codes" && (
          <ProductCodesContent colors={colors}/>
        )}
         {selectedTab === "Organization Types" && (
          <OrganizationTypesContent colors={colors}/>
        )}
        {selectedTab === "Webinar" && (
          <WebinarContent colors={colors}/>
        )}
         {selectedTab === "Merge Accounts" && (
          <MergeAccountsContent colors={colors}/>
        )}
         {selectedTab === "Resources" && (
          <ResourcesContent colors={colors}/>
        )}
        {selectedTab === "Quotes" && (
          <QuotesContent colors={colors}/>
        )}

        { selectedTab === "Renewals" && (
          <RenewalContent colors={colors} />
        )
        }
      </Container>
    </DashboardContainer>
  );
};

export default OtherPage;
